import React, {useState, useEffect, useContext} from 'react';
import {Swiper, SwiperSlide} from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import {Pagination, Navigation, Autoplay} from 'swiper/modules';
import {ApiContext} from '../App';
import {useNavigate} from 'react-router-dom';

interface SlideData {
    title: string;
    subtitle?: string;
    description: string;
    descriptionMobile: string;
    shareXLink?: string;
    shareFacebookLink?: string;
    eventLink?: string;
    productLink?: string;
    buyLink?: string;
    status?: string;
    salePossible?: string;
    activeCheck?: string;
    sub1ImagePath?: string;
    sub2ImagePath?: string;
    link1: string;
}

interface Section02Props {
    bg_img2: String;
    setVisibleSlide: (bool: boolean) => void;
}

const Section02: React.FC<Section02Props> = ({bg_img2, setVisibleSlide}) => {
    const apiUrl = useContext(ApiContext);
    const navigate = useNavigate();
    const [slides, setSlides] = useState<SlideData[]>([]);

    const [isLandscape, setIsLandscape] = useState(window.innerWidth > window.innerHeight);

    const checkOrientation = () => {
        setIsLandscape(window.innerWidth > window.innerHeight);
    };

    useEffect(() => {
        // 초기화 시 한 번 체크
        checkOrientation();

        // resize 및 orientationchange 이벤트로 화면 크기 변화 감지
        window.addEventListener('resize', checkOrientation);
        window.addEventListener('orientationchange', checkOrientation);

        // 컴포넌트 언마운트 시 이벤트 리스너 정리
        return () => {
            window.removeEventListener('resize', checkOrientation);
            window.removeEventListener('orientationchange', checkOrientation);
        };
    }, []);

    useEffect(() => {
        const fetchSlides = async () => {
            try {
                const response = await fetch(`${apiUrl}/api/notice/list`);
                const result = await response.json();

                if (result.code === 200) {
                    const fetchedSlides = result.data.map((item: any) => ({
                        title: item.title,
                        description: item.listContent,
                        descriptionMobile: item.listContentMobile,
                        shareXLink: `https://www.facebook.com/sharer/sharer.php?u=http://xrp-plus.site/pages/eventDetail/${item.eventSeq}`,
                        shareFacebookLink: `https://www.facebook.com/sharer/sharer.php?u=http://xrp-plus.site/pages/eventDetail/${item.eventSeq}`,
                        eventLink: `/pages/eventDetail/${item.eventSeq}`,
                        productLink: `/pages/ProductDetail/${item.shopSeq}`,
                        buyLink: `/pages/ProductBuy/${item.productSeq}`,
                        status: `${item.status}`,
                        salePossible: `${item.salePossible}`,
                        sub1ImagePath: item.sub1ImagePath,
                        sub2ImagePath: item.sub2ImagePath,
                        activeCheck: `${item.activeCheck}`,
                        link1: item.link1
                    }));

                    setSlides(fetchedSlides);

                    if (fetchedSlides.length > 0) {
                        setVisibleSlide(true);
                    } else {
                        setVisibleSlide(false);
                    }
                } else {
                    console.error('Error fetching slides:', result.message);
                    setVisibleSlide(false);
                }
            } catch (error) {
                console.error('Failed to fetch slides:', error);
                setVisibleSlide(false);
            }
        };

        fetchSlides();
    }, [apiUrl]);

    function isPC() {
        const userAgent = navigator.userAgent;

        // 모바일 기기에 해당하는 키워드
        const mobileKeywords = [
            "Android", "iPhone", "iPod", "BlackBerry", "Windows Phone", "webOS"
        ];

        // User Agent에 모바일 키워드가 포함되어 있으면 모바일로 간주
        return !mobileKeywords.some(keyword => userAgent.includes(keyword));
    }

    function isSmartphone() {
        const userAgent = navigator.userAgent.toLowerCase();

        // 스마트폰 기기에 해당하는 키워드 (태블릿 제외)
        const smartphoneKeywords = ["iphone", "ipod", "blackberry", "windows phone", "webos"];

        // 안드로이드 태블릿 감지 (Android인데 Mobile 키워드가 없으면 태블릿)
        const isAndroidTablet = userAgent.includes("android") && !userAgent.includes("mobile");

        // 아이패드 감지 (iPadOS 13 이상 대응)
        const isIPad = /ipad/.test(userAgent) ||
            (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

        // 태블릿 감지 (아이패드 + 안드로이드 태블릿)
        const isTablet = isIPad || isAndroidTablet;

        // 화면 너비가 768px 이하이면 모바일로 간주
        const isSmallScreen = window.innerWidth <= 767;

        // 스마트폰만 true (태블릿과 PC는 false), 또는 화면이 작은 경우도 true
        return isSmallScreen || (!isTablet && (smartphoneKeywords.some(keyword => userAgent.includes(keyword)) ||
            (userAgent.includes("android") && userAgent.includes("mobile"))));
    }


    const handleTouchMove = (swiper: { allowSlideNext: boolean; allowSlidePrev: boolean; }) => {
        swiper.allowSlideNext = false;
        swiper.allowSlidePrev = false;
    };


    const handleNavigation = (slide: SlideData) => {
        if (slide.link1) {
            window.open(slide.link1!, "_blank"); // 새 창에서 열기
        } else {
            navigate(slide.buyLink!); // 현재 창에서 이동
        }
    };

    return (

        <>
            <div id="shop" style={{backgroundImage: `url(${bg_img2})`}}>
                <article>
                    {slides && <Swiper
                        modules={[Pagination, Navigation, Autoplay]}
                        pagination={{clickable: true}}
                        loop={true} // 무한 루프 활성화
                        slidesPerView={1} // 한 번에 보이는 슬라이드 개수
                        centeredSlides={true} // 아이템들이 중앙에 오도록 설정
                        onTouchMove={handleTouchMove} // 터치 시 스와이프 방지
                        autoplay={{
                            delay: 5000,
                            disableOnInteraction: false,
                        }}
                    >
                        {slides.map((slide, index) => (
                            <SwiperSlide key={index}>

                                <div className={'shop_wrapper'}>
                                    <div className={'notice_area'}>
                                        <div className={'detail_box'} style={{paddingLeft: '4px'}}
                                             dangerouslySetInnerHTML={{__html: `<h3>${!isSmartphone() ? slide.description : slide.descriptionMobile}</h3>`}}/>
                                    </div>
                                    <div className={"button_box2"}>
                                        {slide.productLink && (
                                            <button
                                                className="box_btn01"
                                                style={{ display: slide.productLink.endsWith('/0') ? 'none' : '' }}
                                                onClick={() => navigate( slide.productLink!)}
                                            >
                                                <img src={slide.sub1ImagePath} alt={'button'} />
                                            </button>
                                        )}

                                        {
                                            slide.salePossible === "true" ? (
                                                slide.status === "Y" ? (
                                                    slide.buyLink ? (
                                                        <button
                                                            className="box_btn02"
                                                            onClick={() => handleNavigation(slide)}
                                                        >
                                                            <img src={slide.sub2ImagePath} alt={'button'}
                                                            />
                                                        </button>
                                                    ) : null
                                                ) : null
                                            ) : null
                                        }
                                        <span className="event_back">.</span>
                                    </div>
                                </div>

                            </SwiperSlide>
                        ))}
                    </Swiper>}
                </article>
            </div>
        </>
    );
};

export default Section02;
